// Core
import React, { lazy, useState, useEffect } from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Row, Col, Form, Input, Divider, Select } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

// App
import { Button } from '../../../components/buttons/buttons';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { RecordViewWrapper } from './Style';
import { Main } from '../../styled';

const PacienteMainForm = lazy(() => import('./Form'));
const CajaView = lazy(() => import('./../caja/Caja'));
const MembresiaView = lazy(() => import('./../membresia/Index'));
const FichaMedicaView = lazy(() => import('./FichaMedica'));
const HistorialClinicoView = lazy(() => import('./HistorialClinico'));

const gridStyle = {
  width: '14%',
  textAlign: 'center',
  fontWeight: '400',
  color: '#2296F3',
  fontSize: '12px',
  minHeight: '60px',

};

const iconStyle = {
  color: '#2296F3',

};

const PacienteExpedienteView = () => {
  const registro = useSelector(state => state.PacienteReducer.record);
  const [submenu, setSubmenu] = useState('main');
  const [nombre, setNombre] = useState('Cargando...');

  useEffect(() => {
    if (registro.id) {
      console.log('paciente: ', registro);
      let membresiaIcono = (<></>);
      if (registro.membresia) {
        membresiaIcono = (<><FontAwesome name="star" /></>)
      }

      let elNombre = registro.nombre.toUpperCase() + ' ' + registro.paterno.toUpperCase() + ' ' + registro.materno.toUpperCase()
      const infoPaciente = (<>{elNombre} {membresiaIcono}  <br /><small><FontAwesome name="building" /> <span style={{ marginRight: '8px' }}>{registro.sucursal}</span> <FontAwesome name="phone" /> {registro.telefono_movil}</small></>)
      setNombre(infoPaciente);
    }
  }, [registro]);

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/clinica/pacientes/listado">Ver todos</Link>
          </Button>,
        ]}
        title={nombre}
      />
      <Main>
        <Card>
          <Card.Grid style={gridStyle}>
            <Link to={`/admin/clinica/caja/${registro.id}`} style={iconStyle} >
              <FontAwesome name="dollar" style={iconStyle} /> <br /> Caja de cobro
            </Link>
          </Card.Grid>
          <Card.Grid style={gridStyle}>
            <Link to={`/admin/clinica/pacientes/expediente/ficha-medica/${registro.id}`} style={iconStyle} >
              <FontAwesome name="heartbeat" style={iconStyle} /> <br />  Ficha médica
            </Link>
          </Card.Grid>
          <Card.Grid style={gridStyle}>
            <Link to={`/admin/clinica/pacientes/expediente/membresia/${registro.id}`} style={iconStyle} >
              <FontAwesome name="id-card-o" style={iconStyle} /> <br />  Membresía
            </Link>
          </Card.Grid>
          <Card.Grid style={gridStyle}>
            <Link to={`/admin/clinica/pacientes/expediente/presupuesto/${registro.id}`} style={iconStyle}>
              <FontAwesome name="list-alt" style={iconStyle} /> <br />   Presupuesto
            </Link>
          </Card.Grid>
          <Card.Grid style={gridStyle}>
            <Link to={`/admin/clinica/agenda/${registro.id}`} style={iconStyle} >
              <FontAwesome name="calendar" style={iconStyle} /> <br />  Agendar cita
            </Link>
          </Card.Grid>
          <Card.Grid style={gridStyle}>
            <Link to={`/admin/clinica/pacientes/expediente/historial-clinico/${registro.id}`} style={iconStyle}>
              <FontAwesome name="book" style={iconStyle} /> <br />  Historial clínico
            </Link>
          </Card.Grid>
          <Card.Grid style={gridStyle}>
            <Link to={`/admin/clinica/pacientes/expediente/estado-cuenta/${registro.id}`} style={iconStyle}>
              <FontAwesome name="money" style={iconStyle} />  <br />  Estado de cuenta
            </Link>
          </Card.Grid>
        </Card>
        <Card>
          <PacienteMainForm />
        </Card>

      </Main >
    </>
  );
};

export default PacienteExpedienteView;
